module.exports = __webpack_public_path__ + "static/media/5.5c75b1ad.jpg";